import HttpServices from './index';

class StaticPagesService extends HttpServices {
  getPopupContent = page => this.http.get(`/pages/${page}`);
}

export default new StaticPagesService();
